import { MenuItem, useToast } from '@chakra-ui/react';
import { faMicrochip } from '@fortawesome/free-solid-svg-icons';
import { useFlag } from '@unleash/proxy-client-react';
import { useMutation } from 'urql';
import { RunClassificationDocument } from '../../gql/graphql';
import SparkelIcon from '../common/icon/SparkelIcon';

// Simple way to prevent triggering multiple times for same model within a session
const triggeredForModels: string[] = [];

export default function TriggerClassificationMenuItem({
  modelId,
}: {
  modelId: string;
}) {
  const enableClassification = useFlag('enable-classification');
  const toast = useToast();
  const [runClassificationResult, runClassification] = useMutation(
    RunClassificationDocument
  );

  const handleTrigger = async () => {
    // simulate trigger with a timeout
    const { error } = await runClassification({ modelId });
    if (error) {
      toast({
        status: 'error',
        title: 'Failed to run classification',
      });
      throw error;
    }
    toast({
      status: 'success',
      duration: 3000,
      title: 'Model classification started. This might take a while',
    });
    triggeredForModels.push(modelId);
  };

  if (!enableClassification) {
    return null;
  }

  return (
    <MenuItem
      isDisabled={
        triggeredForModels.includes(modelId) || runClassificationResult.fetching
      }
      icon={<SparkelIcon icon={faMicrochip} fixedWidth />}
      onClick={handleTrigger}
    >
      Start AI classification
    </MenuItem>
  );
}
